import { useLocation, useNavigate, useOutletContext } from 'react-router-dom'
import { useParams } from 'react-router-dom'

import { Form as FactorialForm } from 'factorial-form'
import { ProjectManagementProjectDetailsPageExportProjectDetailsModalPageDocument } from 'generated/resources/graphql'
import { ProjectForSelectFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'
import { useQuery } from 'modules/core/hooks/useQuery'

import Loading from 'modules/layout/components/Page/Loading'
import ExportProjectsModal from 'modules/project_management/components/modals/ExportProjectsModal'
import {
  EXPORT_PROJECTS_FORM_SCHEMA,
  getDefaultExportFormAttributes,
} from 'modules/project_management/components/modals/ExportProjectsModal/types'

interface LocationState {
  projectForSelect?: ProjectForSelectFragment
}

const ExportProjectDetailsModalPage = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const { employee } = useCurrentSession()
  const { hasExpenses, hasFlexibleTracking } = useOutletContext<{
    hasExpenses: boolean
    hasFlexibleTracking: boolean
  }>()

  const location = useLocation()
  const state: LocationState = location.state

  const { projectForSelect } = state || {
    projectForSelect: undefined,
  }

  const form = useLazyRef(
    () =>
      new FactorialForm(
        getDefaultExportFormAttributes({ project_ids: id ? [id] : [] }),
        EXPORT_PROJECTS_FORM_SCHEMA
      )
  ).current

  const onClose = () => {
    navigate(-1)
  }

  const { data: policies, loading: loadingPolicies } = useQuery(
    ProjectManagementProjectDetailsPageExportProjectDetailsModalPageDocument
  )

  if (loadingPolicies) return <Loading />
  if (!policies) return null

  const canSeeCost = policies.projectManagement._policies.projectSeeCost.can
  const hasTimeTrackingSection =
    policies.attendance._policies.sidebarSeeAttendanceCompanyTopLevelItem.can

  const canExportData =
    policies.projectManagement._policies.projectManage.can &&
    !!employee &&
    (hasTimeTrackingSection || hasExpenses || hasFlexibleTracking)

  if (!canExportData) return null

  return (
    <ExportProjectsModal
      exportForm={form}
      onClose={onClose}
      project={projectForSelect}
      canSeeCost={canSeeCost}
      hasTimeTrackingSection={hasTimeTrackingSection}
      hasFlexibleTracking={hasFlexibleTracking}
    />
  )
}

export default ExportProjectDetailsModalPage
